
import React, { Component } from 'react';
import Select from 'react-select';
import { LIBRARIES } from './helpers/libraryHelpers';

class Settings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      libraries: [],
      selected: 'one',
      options: []
    }
    this.handleSelectChange = this.handleSelectChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ libraries: nextProps.libraries })
  }

  componentDidMount() {
    this.setState({
      options: LIBRARIES
    })
  }

  handleSelectChange (libraries) {
		this.setState({ libraries });
    this.props.settingsChange(libraries)
	}

  focusHandler(e) {
    // COULD DO THIS WITH MUTATION OBSERVER - https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
    window.setTimeout(function() {
      if (document.getElementsByClassName('Select-menu-outer').length > 0) {
        var div = document.getElementsByClassName('Select-menu-outer')[0].children[0];
        div.scrollTop = 0;
      }
    }, 10)
  }

  render() {
    return (
      <div className='options-settings'>
        <p>Libraries:</p>
        <Select
          multi
          disabled={this.state.disabled}
          value={this.state.libraries}
          placeholder="Select your library(ies)"
          options={this.state.options}
          onChange={this.handleSelectChange}
          focusedOption={this.state.options[5]}
          onFocus={this.focusHandler}
        />
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </div>
    )
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/Settings.js